import { AddToCartChildProps } from '../AddToCart/AddToCart';
import s from './StepperButton.module.scss';
import Icon from 'ui-v2/components/Icon/Icon';
import { Typography } from 'ui-v2/components/Typography';
import classNames from 'classnames';
import { Loader } from 'ui-v2/components/Loader';

export const StepperButton = ({
  isLoading,
  onAddToCart,
  isSmall,
  qty,
  cartItemId,
  size = "small"
}: AddToCartChildProps) => {
  return (
    <div className={s.root}>
      <button
        className={classNames(s.btn, s[size], {
          [s.disabled]: qty < 1,
        })}
        disabled={isLoading}
        onClick={(e) => {
          e.stopPropagation()
          onAddToCart(e, qty - 1, cartItemId)
        }
        }
      >
        <Icon name="MinuRegular" width={size == "small" ? 16 : 20} height={size === "small" ? 16 : 20} />
      </button>
      {
        isLoading ? (
          <div className={s.text}>
            <Loader width={24} color="brand" />
          </div>
        ) :
          (
            <div className={s.text}>
              <Typography
                color="brand"
                variant="label_1_bold"
                label={qty}
              />
            </div>
          )}
      <button
        onClick={(e) => onAddToCart(e, qty + 1, cartItemId)}
        className={classNames(s.btn, s[size])}
      >
        <Icon name="PlusRegular" width={size == "small" ? 16 : 20} height={size === "small" ? 16 : 20} />
      </button>

    </div>

  );
};
